<!-- HEADER -->
<div *ngIf="isLoading" class="loader-wrapper">
    <mat-spinner diameter="40"></mat-spinner>
</div>

<mat-card-header class="m-l-15 bill-header" *ngIf="!isLoading">
    <!-- Bill Number -->
    <div class="row justify-content-between m-b-5" *ngIf="isEditMode || billNoFromApi">
        <div class="col-sm-6 align-items-center p-r-0">
            <h4 class="mat-subtitle-2 f-s-18 f-w-600">
                {{ 'LABEL.BILL_NO' | translate }}:
                <span class="text-primary">{{ billNoFromApi }}</span>
            </h4>
        </div>

        <div class="col-sm-5 d-flex align-items-center justify-content-md-end">
            <span class="f-w-600 f-s-15">{{ 'LABEL.PATIENT_NAME' | translate }}:</span>
            {{ getPatientName() }}
        </div>
        <div class="col-sm-1 text-right">
            <button mat-icon-button (click)="onCloseDialog()">
                <i-tabler name="x" class="icon-20"></i-tabler>
            </button>
        </div>
    </div>

    <!-- Payment Summary Bar (uses existing row/col classes) -->
    <div class="row align-items-center" *ngIf="currentBillId">
        <div class="col-3">
            <span class="f-w-500">{{ 'LABEL.TOTAL' | translate }}: </span>
            <span class="f-w-700">{{ grandTotal | indianCurrency }}</span>
        </div>
        <div class="col-3">
            <span class="f-w-500 text-paid">{{ 'LABEL.PAID' | translate }}: </span>
            <span class="f-w-700 text-paid">{{ paidAmount | indianCurrency }}</span>
        </div>
        <div class="col-3">
            <span class="f-w-500 text-due">{{ 'LABEL.DUE' | translate }}: </span>
            <span class="f-w-700 text-due">{{ dueAmount | indianCurrency }}</span>
        </div>
        <div class="col-3 text-right" *ngIf="canPrint">
            <button mat-icon-button color="primary" (click)="printBill()"
                matTooltip="{{ 'BUTTON.BTN_PRINT' | translate }}">
                <i-tabler name="printer" class="text-primary icon-20"></i-tabler>
            </button>
        </div>
    </div>

</mat-card-header>

<!-- TABBED CONTENT -->
<mat-dialog-content *ngIf="!isLoading">
    <mat-tab-group [selectedIndex]="activeTabIndex" (selectedIndexChange)="onTabChange($event)">

        <!-- TAB 1: INVOICE DETAILS -->
        <mat-tab [label]="'TAB.BILL_DETAILS' | translate">
            <div [formGroup]="addForm" class="tab-layout add-invoice-list">
                <div class="invoice-table-scroll">
                    <div class="table-responsive">
                        <table class="table table-hover b-1 rounded w-100">
                            <thead>
                                <tr>
                                    <th class="p-0"></th>
                                    <th class="p-2">{{ 'LABEL.SELECT_CHARGE' | translate }}</th>
                                    <th class="p-2 column-category" *ngIf="isIPDBill">{{
                                        'LABEL.INSURANCE_CHARGE_CATEGORY' | translate
                                        }}</th>
                                    <th class="p-2">{{ 'LABEL.QTY' | translate }}</th>
                                    <th class="p-2">{{ 'LABEL.RATE' | translate }}</th>
                                    <th class="p-2">{{ 'LABEL.TOTAL_AMOUNT' | translate }}</th>
                                    <th class="p-2"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Static Appointment Row -->
                                <tr [formGroup]="addForm.get('staticChargeRow')" *ngIf="shouldShowStaticRow()">
                                    <td class="text-no"></td>
                                    <td class="p-2">
                                        <mat-form-field appearance="outline" class="input-270 hide-hint">
                                            <input type="text" matInput formControlName="name"
                                                [readonly]="isInvoiceEditingDisabled()" />
                                        </mat-form-field>
                                    </td>
                                    <td class="p-2 column-category" *ngIf="isIPDBill">
                                        <span class="f-w-500 f-s-14"
                                            [matTooltip]="getInsuranceCategoryName(addForm.get('staticChargeRow')?.get('insuranceChargeCategory')?.value)">{{
                                            addForm.get('staticChargeRow')?.get('name')?.value ?
                                            getInsuranceCategoryName(addForm.get('staticChargeRow')?.get('insuranceChargeCategory')?.value)
                                            : ''
                                            }}</span>
                                    </td>
                                    <td class="p-2">
                                        <mat-form-field appearance="outline" class="input-100 hide-hint">
                                            <input type="text" matInput class="text-right" formControlName="quantity"
                                                readonly />
                                        </mat-form-field>
                                    </td>
                                    <td class="p-2">
                                        <mat-form-field appearance="outline" class="input-150 hide-hint">
                                            <input type="text" matInput class="text-right" formControlName="rate"
                                                (input)="itemsChanged()" [readonly]="isInvoiceEditingDisabled()" />
                                        </mat-form-field>
                                    </td>
                                    <td class="p-2">
                                        <mat-form-field appearance="outline" class="input-200 hide-hint">
                                            <input type="text" matInput class="text-right" formControlName="total"
                                                readonly />
                                        </mat-form-field>
                                    </td>
                                    <td></td>
                                </tr>

                                <!-- Dynamic Rows -->
                                @for (row of addForm.get('rows')['controls']; track row; let index = $index; let last =
                                $last) {
                                <tr>
                                    <td class="text-no"></td>
                                    <td class="p-2">
                                        <mat-form-field appearance="outline" class="input-270 hide-hint">
                                            <input #chargeInput type="text" matInput [formControl]="row.get('charge')"
                                                [matAutocomplete]="autoCharge"
                                                [readonly]="isInvoiceEditingDisabled()" />
                                            <mat-autocomplete #autoCharge="matAutocomplete" [displayWith]="displayFn"
                                                (optionSelected)="onChargeSelected($event.option.value, row); focusOnLastChargeInput(index)">
                                                <mat-option *ngFor="let option of (row.filteredBillcharges$ | async)"
                                                    [value]="option" [disabled]="isChargeAlreadySelected(option, row)">
                                                    {{ displayFn(option) }}
                                                </mat-option>
                                                <mat-option *ngIf="shouldShowAddOption(row)"
                                                    [value]="row.get('charge')?.value" class="mat-option-add">
                                                    <span class="f-w-700">Add "{{ row.get('charge')?.value }}"</span>
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </td>
                                    <td class="p-2 column-category" *ngIf="isIPDBill">
                                        <span class="f-w-500 f-s-14"
                                            [matTooltip]="getInsuranceCategoryName(row.get('charge')?.value?.specialityName)">{{
                                            getInsuranceCategoryName(row.get('charge')?.value?.specialityName)
                                            }}</span>
                                    </td>
                                    <td class="p-2">
                                        <mat-form-field appearance="outline" class="input-100 hide-hint">
                                            <input type="text" matInput min="1" class="text-right"
                                                [formControl]="row.get('quantity')" (input)="itemsChanged()"
                                                [readonly]="isInvoiceEditingDisabled()" />
                                        </mat-form-field>
                                    </td>
                                    <td class="p-2">
                                        <mat-form-field appearance="outline" class="input-150 hide-hint">
                                            <input type="number" matInput min="1" class="text-right"
                                                [formControl]="row.get('rate')" (input)="itemsChanged()"
                                                [readonly]="isInvoiceEditingDisabled()" />
                                        </mat-form-field>
                                    </td>
                                    <td class="p-2">
                                        <mat-form-field appearance="outline" class="input-200 hide-hint">
                                            <input matInput disabled class="text-right"
                                                [value]="(row.get('quantity')?.value ?? 0) * (row.get('rate')?.value ?? 0) | indianCurrency" />
                                        </mat-form-field>
                                    </td>
                                    <td class="p-2 input-85 whitespace-nowrap flex items-center justify-end">
                                        <button mat-icon-button color="primary" class="text-left"
                                            *ngIf="last && isChargeSelected(row) && !isInvoiceEditingDisabled()"
                                            (click)="onAddRow()">
                                            <i-tabler name="plus" class="icon-18 d-flex"></i-tabler>
                                        </button>
                                        <button mat-icon-button color="warn"
                                            *ngIf="!isChargeSelected(row) && index > 0 && !isInvoiceEditingDisabled()"
                                            (click)="onRemoveRow(index)">
                                            <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
                                        </button>
                                        <button mat-icon-button color="primary"
                                            *ngIf="isChargeSelected(row) && !(isEditMode && index === 0) && !isInvoiceEditingDisabled()"
                                            (click)="onRemoveRow(index)">
                                            <i-tabler name="trash" class="icon-18 d-flex"></i-tabler>
                                        </button>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </mat-tab>

        <!-- TAB 2: PAYMENTS (only after save) -->
        <mat-tab *ngIf="shouldShowPaymentsTab()">
            <ng-template mat-tab-label>
                {{ 'TAB.PAYMENTS' | translate }}
                <span *ngIf="paymentCount > 0" class="m-l-8">({{ paymentCount }})</span>
            </ng-template>

            <div class="tab-layout">
                <!-- When there are payments -->
                <ng-container *ngIf="paymentCount > 0">
                    <!-- Take Payment Button (top right) -->
                    <div class="row m-b-5" *ngIf="dueAmount > 0">
                        <div class="col-12 text-right">
                            <button mat-flat-button color="primary" (click)="takePayment()">
                                <div
                                    class="d-flex align-items-center inbox-list rounded cursor-pointer text-hover-primary">
                                    <i-tabler name="plus" class="m-r-12 icon-20"></i-tabler>
                                    <span class="f-w-400 f-s-14"> {{ 'BUTTON.BTN_TAKE_PAYMENT' | translate }} ({{
                                        dueAmount | indianCurrency }})</span>
                                </div>
                            </button>
                        </div>
                    </div>

                    <!-- Payment History Table -->
                    <div class="payment-table-scroll">
                        <table mat-table [dataSource]="paymentDataSource" class="w-100 payment-table">
                            <!-- Date Column -->
                            <ng-container matColumnDef="paymentDate">
                                <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">{{ 'LABEL.DATE' | translate
                                    }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.paymentDate | date:'dd-MMM-yyyy' }}
                                </td>
                            </ng-container>

                            <!-- Method Column -->
                            <ng-container matColumnDef="paymentMethod">
                                <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">{{ 'LABEL.METHOD' |
                                    translate }}</th>
                                <td mat-cell *matCellDef="let element">
                                    <span class="payment-badge"
                                        [ngClass]="(element.paymentTypeName === 'Cash' || !element.paymentTypeName) ? 'cash' : 'other'">
                                        {{ element.paymentTypeName || 'Cash' }}
                                    </span>
                                </td>
                            </ng-container>

                            <!-- Transaction No Column -->
                            <ng-container matColumnDef="transactionNo">
                                <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">{{ 'LABEL.TRANSACTION_NO' |
                                    translate }}</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.transactionNo | defaultValue }}
                                </td>
                            </ng-container>

                            <!-- Description Column -->
                            <ng-container matColumnDef="description">
                                <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600">{{ 'LABEL.DESCRIPTION' |
                                    translate }}</th>
                                <td mat-cell *matCellDef="let element" class="ellipsis-text"
                                    [matTooltip]="element.description">
                                    {{ element.description | defaultValue }}
                                </td>
                            </ng-container>

                            <!-- Amount Column -->
                            <ng-container matColumnDef="amount">
                                <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-600 text-right">{{
                                    'LABEL.AMOUNT'
                                    | translate }}</th>
                                <td mat-cell *matCellDef="let element" class="text-right">{{ element.amount |
                                    indianCurrency }}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="paymentDisplayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: paymentDisplayedColumns;"></tr>
                        </table>
                    </div>

                    <!-- Total Received -->
                    <div class="row m-t-16">
                        <div class="col-12 text-right">
                            <span class="f-w-600">{{ 'LABEL.TOTAL_RECEIVED' | translate }}: </span>
                            <span class="f-w-700 f-s-16 text-paid">{{ paidAmount | indianCurrency }}</span>
                        </div>
                    </div>
                </ng-container>

                <!-- Empty State - No payments yet -->
                <ng-container *ngIf="paymentCount === 0">
                    <div class="text-center p-y-48 empty-state">
                        <i-tabler name="receipt-off" class="icon-48 m-b-16 icon-muted"></i-tabler>
                        <p class="mat-body-1 m-b-24 text-muted">{{ 'LABEL.NO_PAYMENTS_YET' | translate }}</p>
                        <button mat-flat-button color="primary" (click)="takePayment()" *ngIf="dueAmount > 0">
                            <div class="d-flex align-items-center inbox-list rounded cursor-pointer text-hover-primary">
                                <i-tabler name="plus" class="icon-18 m-r-8"></i-tabler>
                                {{ 'BUTTON.BTN_TAKE_PAYMENT' | translate }} ({{ dueAmount | indianCurrency }})
                            </div>
                        </button>
                    </div>
                </ng-container>
            </div>
        </mat-tab>

    </mat-tab-group>
</mat-dialog-content>

<!-- SUMMARY SECTION (Invoice Tab Only) -->
<mat-dialog-actions *ngIf="activeTabIndex === 0 && !isLoading">
    <div [formGroup]="addForm" class="summary-section m-r-20">
        <div class="summary-row">
            <span class="label">{{ 'LABEL.SUB_TOTAL' | translate }} : </span>
            <span class="value">{{ subTotal | indianCurrency }}</span>
        </div>
        <div class="summary-row align-center">
            <span class="label">{{ 'LABEL.DISCOUNT' | translate }}</span> <span class="label">:</span>
            <div class="discount-box">
                <mat-form-field appearance="outline" class="input-50 hide-hint">
                    <mat-select formControlName="discountType" (selectionChange)="onDiscountTypeChange()"
                        [disabled]="isInvoiceEditingDisabled()">
                        <mat-option [value]="DiscountType.FixedAmount">₹</mat-option>
                        <mat-option [value]="DiscountType.Percentage">%</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="input-100 hide-hint m-l-5">
                    <input matInput type="text" formControlName="discount" (input)="itemsChanged()" class="text-right"
                        [readonly]="isInvoiceEditingDisabled()" />
                </mat-form-field>
            </div>
        </div>
        <div class="summary-row total-row">
            <span class="value total">{{ 'LABEL.TOTAL' | translate }} : </span>
            <span class="value total">{{ grandTotal | indianCurrency }}</span>
        </div>
    </div>
</mat-dialog-actions>

<!-- FOOTER ACTIONS -->
<mat-divider *ngIf="!isLoading"></mat-divider>
<mat-dialog-actions *ngIf="!isLoading">
    <div class="justify-content-between m-b-10 w-100">
        <div class="col-12 text-right">
            <!-- Close Button -->
            <a mat-stroked-button color="primary" (click)="onCloseDialog()">
                {{ 'BUTTON.BTN_CLOSE' | translate }}
            </a>

            <!-- Invoice Tab Actions -->
            <ng-container *ngIf="activeTabIndex === 0 && !isInvoiceEditingDisabled()">
                <button mat-flat-button color="primary" (click)="saveUpdateBill()"
                    [disabled]="addForm.get('discount').invalid">
                    {{ isEditMode ? ('BUTTON.BTN_UPDATE' | translate) : ('BUTTON.BTN_SAVE' | translate) }}
                </button>
            </ng-container>

        </div>
    </div>
</mat-dialog-actions>

<!-- PRINT SECTION -->
<div class="print-only">
    <div id="print-section">
        <app-bill-print [billData]="printableBillData" [doctorInfo]="doctorInfo" [doctorId]="doctorId"
            [hospitalInfo]="hospitalInfo" [successResult]="successResult" [billType]="billType">
        </app-bill-print>
    </div>
</div>